module.exports = __webpack_public_path__ + "root-b33b72b3/XING-Sans-Bold-3ba114329689bcfb7ffae73fb316f924.woff";